import { Component, OnInit } from '@angular/core';
import { AccessControlService } from '../core/services/accessControl.service';

@Component({
  selector: 'app-base',
  templateUrl: './base.component.html',
  styleUrls: ['./base.component.scss']
})
export class BaseComponent implements OnInit {

  finding: boolean = false;
  showContent: boolean = false;

  public SEC: boolean = false;
  public STB: boolean = false;
  public Directory: boolean = false;

  constructor(private accessControlService: AccessControlService) { 
  }

  ngOnInit(): void {
    this.finding = true;
    this.getUserRoles();

  }
  
  getFinding(finding) {
    this.finding = finding;
  }
  
  async getUserRoles(){
    
    this.accessControlService.checkItHasRoles().subscribe(resp => {
      setTimeout(() => {
        this.showContent = true;
        this.finding = false;
        this.setUserRoles();
      }, 1000);
    });
  }

  async setUserRoles(){

    let roles = this.accessControlService.getRoles();

    if(roles.length == 0 ) {
      this.accessControlService.roles$.subscribe(role => {
        if(role.includes('SEC_Minutes_Officers') || role.includes('SEC_Minutes_Officer')) {
          this.STB = true;
        } else if(role.includes('Recording Searchers')) {
          this.SEC = true;
        } else if(role.includes('directory')) {
          this.Directory = true;
        }
      })

    } else {
      if(roles.includes('SEC_Minutes_Officer') || roles.includes('SEC_Minutes_Officers')) {
        this.STB = true;
      } else if(roles.includes('Recording Searchers')) {
        this.SEC = true;
      } else if(roles.includes('directory')) {
        this.Directory = true;
      }
    }
  }

}
